export const SERVER = {
  name: "Barren County Roleplay",
  short: "BCRP",
  ip: "212.73.137.40:22448",
  mtaLink: "mtasa://212.73.137.40:22448",
  discord: "https://discord.gg/HGJXNNcqfh",
  forum: "/forum",
  facebook: "https://www.facebook.com/profile.php?id=61594986998792",
  tiktok: "https://www.tiktok.com/@barrencountymta",
  site: "https://bc-rp.hu",
  support: "https://vps4you.hu/smsgw.php?r=0&service=202121",
};

export const ASSETS = {
  logo: "/assets/barren-county-logo.png",
  cover: "/assets/borito.png",
  heroBg: "/assets/hatter.png",
  authBg: "/assets/2b3113-9.jpg",
  screenshot: "/assets/mta-screen_2024-01-22_19-18-55.png",
};

export const NAV = [
  { label: "Hírek", href: "#hirek" },
  { label: "Galéria", href: "#galeria", footerOnly: true },
  { label: "Fórum", href: SERVER.forum, route: true },
  { label: "Kapcsolat", href: "#kapcsolat", footerOnly: true },
];

export const ABOUT = {
  eyebrow: "A szerverről röviden",
  title: "Barren County Roleplay",
  text: "Szerverünk ötlete 2026 elején született. Alapját a régi BCRP-mod adja, amelyet rengeteg újdonsággal és fejlesztéssel egészítünk ki.",
  facts: [
    { label: "Megnyitás", value: "2026. december" },
    { label: "Szerver verzió", value: "V1.0" },
  ],
};

export const LINKS = {
  eyebrow: "Linkek, csatlakozás",
  items: [
    { id: "mta", label: "MTA szerver csatlakozás", href: SERVER.mtaLink, meta: SERVER.ip },
    { id: "discord", label: "Discord szerver csatlakozás", href: SERVER.discord, meta: "discord.gg/HGJXNNcqfh", external: true },
    { id: "forum", label: "Átirányítás a fórumra", href: SERVER.forum, meta: "bc-rp.hu/forum", route: true },
    { id: "ucp", label: "Játékos vezérlőpult", href: "/ucp", meta: "Karakter, vagyon és játékfiók", route: true },
    { id: "facebook", label: "Facebook oldal", href: SERVER.facebook, meta: "Barren County Roleplay", external: true },
    { id: "tiktok", label: "TikTok oldal", href: SERVER.tiktok, meta: "@barrencountymta", external: true },
  ],
};

export const NEWS = {
  eyebrow: "Hírek, újdonságok",
  items: [
    {
      id: "hibajavitasok",
      title: "Hibajavítások",
      date: "2026. május 20.",
      text: "A szerverünkön számos hibajavítást végeztünk el, hogy a játékélmény még stabilabb és élvezetesebb legyen minden játékos számára.",
    },
    {
      id: "tippmix",
      title: "Tippmix",
      date: "2026. július 23.",
      text: "Bekerült a tippmix valódi meccsekre is, így a játékosok most már valós eseményekre is fogadhatnak a szerveren.",
    },
    {
      id: "lotto",
      title: "Bekerült a lottó",
      date: "2026. július 28.",
      text: "Bevezetésre került a lottórendszer, amely lehetőséget ad a játékosoknak, hogy különböző nyereményeket nyerjenek. Hétköznaponként szelvényt vásárolhatnak, szombatonként pedig sorsolásra kerül sor.",
    },
    {
      id: "boltrendszer",
      title: "Új bolt rendszer",
      date: "2026. szeptember 15.",
      text: "Elkészült a bolt rendszer, ami minden játékosnak esélyt ad arra, hogy boltot üzemeltessen.",
    },
     {
      id: "repont",
      title: "REpont rendszer",
      date: "2026. szeptember 23.",
      text: "Elkészült a REpont-rendszer: minden elfogyasztott ital után üres üveget kapsz, amelyet a REpont-automatánál adhatsz le.",
    },
         {
      id: "bcring",
      title: "Bone Ring",
      date: "2026. szeptember 27.",
      text: "Elkészült a Bone Ring versenypálya, ahol a játékosok különböző autóversenyeken vehetnek részt. A pálya komppal közelíthető meg.",
    },
        {
      id: "kuka",
      title: "Kuka rendszer",
      date: "2026. szeptember 29.",
      text: "Elkészült a kuka rendszer, amely lehetővé teszi a játékosok számára, hogy a játék világában elhelyezett kukákban \"kincseket\" találjanak.",
    },
          {
      id: "vape",
      title: "Vape rendszer",
      date: "2026. szeptember 29.",
      text: "Elkészült a vape rendszer, ami lehetőséget ad hogy különböző tipusú/ízű vape-eket vásárolhassanak a játékosok.",
    },
           {
      id: "buvar",
      title: "Búvárkodás",
      date: "2026. október 1.",
      text: "Bekerült a szerverre a búvárkodás lehetősége, búvárfelszerelés vásárlása után, tenger alatt lévő szemetek gyűjtése, ha szerencsével jársz értékes tárgyakat is találhatsz.",
    },
             {
      id: "billiard",
      title: "Billiárd",
      date: "2026. október 2.",
      text: "Mostantól a játékosok a szerveren biliárdozhatnak is. Ha akarod egyedül is játszhatsz, vagy barátaiddal mérheted össze tudásodat.Akár tét nélkül vagy tét mellett is játszhatsz.",
    },
               {
      id: "hasznaltauto",
      title: "Használtautó kereskedés",
      date: "2026. október 3.",
      text: "Lehetőséged adódik használtautókereskedés vásárlására, ahol a megvásárolt autóidat tovább értékesítheted.",
    },
               {
      id: "chatgui",
      title: "Chat GUI",
      date: "2026. október 8.",
      text: "Chat felület egyedi megjelenést kapott a jobb láthatóság érdekében",
    },
               {
      id: "sakk",
      title: "Sakk",
      date: "2026. október 9.",
      text: "Barátaiddal lehetőség nyílik sakkpartikra a szerveren.",
    },
               {
      id: "briefcase",
      title: "Aktatáska",
      date: "2026. október 9.",
      text: "Aktatáska jelenik meg a karaktered kezében 2.000.000$ készpénzegyenleg esetén.",
    },
               {
      id: "teljesitmeny",
      title: "Teljesítmény javítás",
      date: "2026. október 9.",
      text: "Gyorsabb betöltési idő és jobb teljesítmény a szerveren. Csatlakozástól játékba lépésig mindössze 50mp alatt történik.",
    },
               {
      id: "openpass",
      title: "Opening Pass",
      date: "2026. október 9.",
      text: "Bekerült az opening pass a szerverre, ami majd különleges jutalmakat biztosít a játékosoknak.",
    },
                  {
      id: "bonestock",
      title: "Barren County Stock Market",
      date: "2026. október 10.",
      text: "Bekerült a Barren County Stock Market a szerverre, ahol a játékosok részvényekkel kereskedhetnek és profitot szerezhetnek. A részvények árfolyama a játékosok befektetésétől függ.",
    },
                  {
      id: "ucp",
      title: "UCP",
      date: "2026. október 10.",
      text: "Bekerült az UCP az oldalra, ami lehetővé teszi a játékosok számára a fiókjuk kezelését és különleges funkciók elérését.(folyamatos fejlesztés alatt)",
    },
                  {
      id: "repontupd",
      title: "REpont update",
      date: "2026. október 10.",
      text: "Frissült a REpont rendszer a szerveren, ami új funkciókat és javításokat tartalmaz a játékosok számára. 20db üres üveg esetén zsákba rendezi, ami látható is a karakter kezében.",
    },
                {
      id: "crypto",
      title: "Crypto rendszer",
      date: "2026. október 12.",
      text: "Bevezetésre került a crypto rendszer a szerveren, saját magadnak állíthatod össze a gépeket minden hardver különböző tulajdonsággal bír, amivel a szerverteremben bányászni tudsz és megfelelő profitot szerezhetsz.",
    },
                {
      id: "kertesz",
      title: "Kertész munka",
      date: "2026. október 12.",
      text: "Bevezetésre került a kertész munka a szerveren, ahol a játékosok kertészeti munkát végezhetnek.",
    },
    {
      id: "felnilop",
      title: "Felni eltulajdonítása",
      date: "2026. október 13.",
      text: "Bevezetésre került a felni eltulajdonítása a szerveren, ahol az emelőgép megvásárlásával leszerelhetjük a felnit az autókról amit aztán értékesíthetünk. Óránként egy alkalommal használható (szabályzat külön ki fog térni a használatához). Az eltulajdonított autó felnije 30perc után visszakerül az autóra.",
    },
    {
      id: "automoso",
      title: "Autómosó",
      date: "2026. október 13.",
      text: "Bevezetésre került az autómosó a szerveren, ahol a játékosok autókat moshatnak és tisztíthatnak. Egyedi rendszert fejlesztettünk ki a koszolódás mértékére/esélyére. A rendszer figyelembe veszi az autó típusát és a környezeti tényezőket is.",
    },
    {
      id: "esernyo",
      title: "Esernyő item",
      date: "2026. október 13.",
      text: "Mivel időjárás rendszer is aktíívan működik a szerveren és viharba is belekeveredhetünk ezért bevezetésre került az esernyő item a szerveren, amelyet a játékosok használhatnak esős időben. Esernyő nélkül a képernyőnkön esőcseppeket láthatunk, de esernyővel védve magunkat minimalizálódik az effekt."
    },
      {
      id: "kulcs",
      title: "Autókulcs",
      date: "2026. október 14.",
      text: "A szabványos kocsikulcs kezelés azaz K betű megnyom és nyitódik/záródik az autó, rendszert lecseréltük egy megjelenő kocsikulcsra ahol kattintással nyithatjuk/zárhatjuk az autót.",
    },
      {
      id: "gcase",
      title: "Globális láda",
      date: "2026. október 14.",
      text: "Bekerült egy Tulajdonos által vezérelt globális láda rendszer. A rendszer parancsra lespawnolja a ládákat a térkép különböző pontjain, ahol a játékosok megtalálhatják és kinyithatják azokat. Ládában mindenféle jó található, élelmiszerektől kezdve fegyverekig és ritka tárgyakig.Nemutolsó sorban PP is nyitható. Sok szerencsét!",
    },
        {
      id: "speedometer",
      title: "Sebességmérő",
      date: "2026. október 14.",
      text: "Új dizájnt kapott a sebességmérő a szerveren, letisztult,minimalista,modern stílusban",
    },
          {
      id: "melynyomo",
      title: "Mélynyomó",
      date: "2026. október 15.",
      text: "Bekerült a mélynyomó a szerverre, amely megvásárlásával a rádió hangzása mélyebb és erőteljesebb lesz. Nem csak az autóban ülők érzékelik a kiemelkedő basszust, hanem a környezetükben lévők is.",
    },
    {
      id: "inventory",
      title: "Inventory",
      date: "2026. október 15.",
      text: "Új dizájnt kapott az inventory rendszer, letisztult, modern stílusban.",
},
{
      id: "tokenshop",
      title: "Token shop",
      date: "2026. október 15.",
      text: "Bekerült a token shop rendszer, játszott órák után kapsz 1DB tokent, amit be tudsz váltani pénzre, vagy különböző tárgyakra.",
},
    {
      id: "utanfuto",
      title: "Utánfutó",
      date: "2026. október 15.",
      text: "Bekerült az utánfutó a szerverre, amelyet a játékosok használhatnak különböző tárgyak szállítására. Későbbiekben nagy szerepet fog kapni a játékban.",
},
    {
      id: "ercfel",
      title: "Ércfeldolgozás",
      date: "2026. október 19.",
      text: "Mostantól az érceket, a játékosok feldolgozhatják,eszterga gépeken így értékes nyersanyagokat nyerhetnek belőlük.",
},
    {
      id: "Grill",
      title: "Grill",
      date: "2026. október 19.",
      text: "A boltban mostantól kapható lesz a grill, amelyet a játékosok használhatnak sütésre. Amire szükséged lesz 1 csomag faszén, gyújtó, grill és nyers kolbasz. Amiből sült kolbászt süthetünk a grillen és el is fogyaszthatjuk.",
},
    {
      id: "telefon",
      title: "Telefon",
      date: "2026. október 19.",
      text: "Megújult a telefon rendszer a szerveren, letisztult, modern stílusban.",
},
    {
      id: "vallalkozas",
      title: "Vállalkozás",
      date: "2026. október 19.",
      text: "Mostantól a játékosok saját vállalkozást indíthatnak a szerveren, amely lehetőséget biztosít számukra, hogy különböző tevékenységekből bevételt szerezzenek. Rendezvény szervezéstől - Személyszállításig számos lehetőség áll rendelkezésre. A választható cégtipusok Egyéni vállalkozó (EV) és Korlátolt Felelősségű Társaság (Kft.).",
},
    {
      id: "felTuning",
      title: "Felni Tuning",
      date: "2026. október 24.",
      text: " Felnik módosítása egyedibbé tétele,távolság,méret,dőlésszög.",
},
    {
      id: "TurboTuning",
      title: "Turbo Tuning",
      date: "2026. október 24.",
      text: " Turbó mostantól egyedileg testreszabható.Töltés,lefújás hangtípus változtatható.És a hangereje is állítható.",
},
    {
      id: "BackfTuning",
      title: "Backfire Tuning",
      date: "2026. október 24.",
      text: " Backfire mostantól egyedileg testreszabható.Töltés,lefújás hangtípus változtatható.Láng méret és pozíció állítható",
},
    {
      id: "frakciotraf",
      title: "Frakció Traffipax",
      date: "2026. október 24.",
      text: "Mostantól a rendőrök lehelyezhetnek traffipaxokat a szerveren, de manuális működéssel aktiválhatók.Azaz az autókat a rendőrök tudják mérni a traffipaxok segítségével.",
},
    {
      id: "farm",
      title: "Farm rendszer",
      date: "2026. október 26.",
      text: "Mostantól a játékosok saját farmot üzemeltethetnek a szerveren, ahol különböző növényeket termeszthetnek. A farmok lehetőséget biztosítanak a gazdasági tevékenységek bővítésére és a játékosok bevételszerzésére.",
},
    {
      id: "meheszet",
      title: "Méhészet",
      date: "2026. október 26.",
      text: "Mostantól a játékosok saját méhészetet üzemeltethetnek a szerveren, ahol méheket tarthatnak és mézet termelhetnek. A méhészetek lehetőséget biztosítanak a gazdasági tevékenységek bővítésére és a játékosok bevételszerzésére.",
},
    {
      id: "forgalmi",
      title: "Forgalmi",
      date: "2026. október 27.",
      text: "Mostantól a játékosok forgalmi engedélyt szerezhetnek a szerveren, amely lehetővé teszi számukra, hogy legálisan vezethessenek járműveket.",
},
    {
      id: "dash",
      title: "Dashboard",
      date: "2026. október 27.",
      text: "A a megújult dashboard lehetővé teszi a játékosok számára, hogy áttekintsék a szerveren zajló eseményeket, statisztikákat és egyéb fontos információkat.",
},
    {
      id: "vadasz",
      title: "Vadászat",
      date: "2026. október 28.",
      text: "Mostantól a játékosok vadászhatnak a szerveren, különböző állatokat ejthetnek el a vadászat során.",
},
    {
      id: "autolopas",
      title: "Autólopás",
      date: "2026. október 28.",
      text: "Mostantól a játékosok autólopással próbálkozhatnak a szerveren, csak egy zárfeltörő eszközre van szükségük.A rendszer 2 óránként engedélyezi a lopást. Az eltulajdonított autó leadható némi pénzért cserébe (az autó tolajdonából nem törlődik).",
},
    {
      id: "gomba",
      title: "Gombászat",
      date: "2026. október 29.",
      text: "Mostantól a játékosok gombászhatnak a szerveren, különböző gombafajtákat gyűjthetnek a környezetükben.",
},
    {
      id: "sator",
      title: "Sátor",
      date: "2026. október 29.",
      text: "Mostantól a játékosok sátrazhatnak a szerveren, a szerepe a regeneráció és pihenés biztosítása a játékosok számára. Minden sátorban töltött 2 perc után a játékos energiája és életereje visszatöltődik.",
},
    {
      id: "pubtel",
      title: "Publikus telefon",
      date: "2026. október 29.",
      text: "Mostantól a játékosok publikus telefonokat használhatnak a szerveren, hogy kommunikáljanak egymással. Akár illegális tevékenységekre is használhatják.",
},
    {
      id: "forint",
      title: "Forint alapú gazdaság",
      date: "2026. október 29.",
      text: "Mostantól a szerver gazdasága forint alapú, a játékosok pénzügyeit forintban kezelhetik, vásárlásaikat és eladásukat forintban bonyolíthatják le.Törekszünk arra hogy mindenkinek élvezhetőbb legyen a játék, ezért valós árakat fogunk alkalmazni.",
},
    {
      id: "loginp",
      title: "Login panel",
      date: "2026. október 30.",
      text: "A login panel teljes felújításon esett át.",
},
    {
      id: "donater",
      title: "Támogatói rang",
      date: "2026. november 1.",
      text: "Mostantól a támogatásért cserébe a játékosok támogatói rangot szerezhetnek a szerveren. Scoreboardon látható lesz a rangjuk.(Rendszer automatikusan jóváírja a rangot a támogatás után.és 30napig érvényes a rang.)",
},
    {
      id: "dcboost",
      title: "Discord boost",
      date: "2026. november 2.",
      text: "Mostantól a discord boost támogatásért cserébe szerveren egyedi rangot szerezhetnek ami a scoreboardon is látható lesz. (Discordon a megfelelő helyen igényelni kell 30napig érvényes a rang.",
},
  ],
};

export const SUPPORT = {
  title: "PP shop",
  text: "Amennyiben támogatni szeretnéd a szervert, kattints az alábbi gombra.",
  cta: "PP shop",
};

export const CONTACT = {
  eyebrow: "Kérdésed van? Írj nekünk",
  title: "Kapcsolat",
  text: "Ha segítségre van szükséged, hibát találtál, vagy bármilyen kérdésed van, írj nekünk e-mailben.",
  email: "support@bc-rp.hu",
};

export const MARQUEE = [
  "Barren County Roleplay",
  "Csatlakozz hozzánk még ma",
  "Hírek, újdonságok",
  "Fórum",
  "Discord",
  "V1.0",
];

export const GALLERY = [
  { src: "/assets/gallery/versenypalya.jpg", alt: "Versenypálya" },
  { src: "/assets/gallery/horgaszhely.jpg", alt: "Horgászhely" },
];

export const FOOTER = {
  copyright: "© 2026 BC-RP.HU - Minden jog fenntartva!",
  credit: "A weboldalt készítette sTVAN",
};
